export default __webpack_public_path__ + "static/media/IMG_021.45676368.jpg";